'use client';

import { type AnchorHTMLAttributes } from 'react';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
  source: string;
};

export default function WhatsappLink({ source, children, ...props }: Props) {
  function handleClick() {
    window.gtag?.('event', 'Iscrizione_WA', {
      event_category: 'engagement',
      event_label: source,
    });
  }

  return (
    <a {...props} onClick={handleClick}>
      {children}
    </a>
  );
}
